<script>
import PolicyBeneficiaryInfo from '@components/admin/affiliate-policy-beneficiary-info'
import {
  fetchPolicyBeneficiaries,
  deletePolicyBeneficiary,
  fetchPolicy,
} from '@apis/admin/affiliate'
import { mapState } from 'vuex'
import fromPairs from 'lodash/fromPairs'

export default {
  components: { PolicyBeneficiaryInfo },
  props: {
    policy_seq: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      beneficiaries: [],
      target_beneficiary_seq: 0,
      policy_info: null,
      show_beneficiary_info: false,
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
  },
  watch: {
    policy_seq() {
      this.init()
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.loadPolicy()
        .then(() => Promise.all([this.loadBeneficiaries()]))
        .catch((e) => this.$toasted.error(e.message))
    },
    async loadPolicy() {
      const { policy_info } = await fetchPolicy(this.policy_seq)

      this.policy_info = policy_info
    },
    async loadBeneficiaries() {
      const { data } = await fetchPolicyBeneficiaries(this.policy_seq)

      this.beneficiaries = data
    },
    handleCreateBeneficiary() {
      this.show_beneficiary_info = true
      this.target_beneficiary_seq = null
    },
    handleUpdateBeneficiary({ seq }) {
      this.show_beneficiary_info = true
      this.target_beneficiary_seq = seq
    },
    handleBeneficiarySubmit(seq) {
      this.init()
      this.target_beneficiary_seq = seq
    },
    async handleDeleteBeneficiary(seq) {
      try {
        if (
          !(await this.$confirm(
            this.$t('admin.confirm_delete'),
            this.$t('admin.modal_confirm'),
            {
              type: 'warning',
            }
          ).catch(() => false))
        )
          return

        await deletePolicyBeneficiary(this.policy_seq, seq)
        await this.loadBeneficiaries()
      } catch (e) {
        this.$toasted.error(e.message)
      }
    },
    fromPairs,
  },
}
</script>

<template>
  <div>
    <h3 :class="$style.xeAdmin">{{
      $t('affiliate_policy_beneficiary.allowance_policy_beneficiary')
    }}</h3>
    <table cellspacing="0" cellpadding="0" :class="$style.crossTable">
      <thead>
        <tr>
          <th scope="col"
            ><div>{{
              $t('affiliate_policy_beneficiary.output_order')
            }}</div></th
          >
          <th scope="col"
            ><div>{{
              $t('affiliate_policy_beneficiary.beneficiary_type')
            }}</div></th
          >
          <th scope="col"
            ><div>{{ $t('affiliate_policy_beneficiary.beneficiary') }}</div></th
          >
          <th scope="col">
            <div :class="$style.tRight">
              <a
                href="#"
                :class="[$style.button, $style.black]"
                @click.prevent="handleCreateBeneficiary"
                ><span>{{ $t('admin.add') }}</span></a
              >
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="beneficiary in beneficiaries" :key="beneficiary.seq">
          <td :class="[$style.tCenter, $style.nowrap]">{{
            beneficiary.list_order
          }}</td>
          <td :class="[$style.tCenter, $style.nowrap]">{{
            fromPairs(
              constants.affiliate.policy_beneficiary.beneficiary_type[
                policy_info.target_action
              ]
            )[beneficiary.beneficiary_type]
          }}</td>
          <td :class="[$style.wide]">
            <template v-if="beneficiary.beneficiary_type === 'MEMBER'">
              {{ $t('affiliate_policy_beneficiary.member_unique_number')
              }}{{ beneficiary.member_seq }}인 자
            </template>
            <template v-else-if="beneficiary.beneficiary_type === 'INVITER'">
              {{
                $t('affiliate_policy_beneficiary.relationship_with_originator')
              }}
              {{ beneficiary.invite_depth }}인 자
            </template>
          </td>
          <td :class="[$style.tRight, $style.nowrap]">
            <a
              href="#"
              :class="[$style.button]"
              @click.prevent="handleUpdateBeneficiary(beneficiary)"
              ><span>{{ $t('admin.modify') }}</span></a
            >
            {{ ' ' }}
            <a
              href="#"
              :class="[$style.button, $style.red]"
              @click.prevent="handleDeleteBeneficiary(beneficiary.seq)"
              ><span>{{ $t('admin.delete') }}</span></a
            >
          </td>
        </tr>
        <tr v-if="!beneficiaries.length">
          <td :colspan="5" :class="$style.tCenter">{{
            $t('affiliate_policy_beneficiary.msg_allowance_policy_no')
          }}</td>
        </tr>
      </tbody>
    </table>
    <ElDialog
      :title="
        target_beneficiary_seq
          ? $t('affiliate_policy_beneficiary.allowance_policy_modify')
          : $t('affiliate_policy_beneficiary.allowance_policy_register')
      "
      :visible.sync="show_beneficiary_info"
    >
      <PolicyBeneficiaryInfo
        v-if="show_beneficiary_info"
        :key="target_beneficiary_seq"
        :policy_seq="policy_seq"
        :beneficiary_seq="target_beneficiary_seq"
        @submit="handleBeneficiarySubmit"
      ></PolicyBeneficiaryInfo>
    </ElDialog>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';

.colTable th,
.colTable td {
  vertical-align: middle;
}
.adminRightExtra p {
  margin: 10px 0;
}
</style>
